export default {
  props: {
    classes: {
      type: String,
      default: 'prog-text default'
    }
  },
  data() {
    return {
      stage: this.getStage(this.$store.state.year)
    }
  },
  watch: {
    '$store.state.year': function(val) {
      this.stage = this.getStage(parseInt(val));
    }
  },
  methods: {
    getStage(year) {
      if (year === 0) {
        return 'healthy';
      } else if (year <= 5) {
        return 'early-rrms';
      } else if (year <= 10) {
        return 'late-rrms';
      }
      // year > 10
      return 'spms';
    }
  }
}